import { render } from "./App.vue?vue&type=template&id=26ca1efc&scoped=true"
import script from "./App.vue?vue&type=script&lang=js"
export * from "./App.vue?vue&type=script&lang=js"

import "./App.vue?vue&type=style&index=0&id=26ca1efc&scoped=true&lang=css"

import exportComponent from "E:\\GIT\\WEB\\catch-app\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-26ca1efc"]])

export default __exports__